var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26161",
    d: "M28.889 20.889v2.37a.889.889 0 1 1-1.778 0v-2.37a.889.889 0 1 1 1.778 0zm6.222 6.222h-2.37a.889.889 0 0 0 0 1.778h2.37a.889.889 0 1 0 0-1.778zm-3.13 3.613a.89.89 0 1 0-1.259 1.259l1.678 1.676a.89.89 0 0 0 1.257-1.259zM28 31.852a.889.889 0 0 0-.889.889v2.37a.889.889 0 1 0 1.778 0v-2.37a.889.889 0 0 0-.889-.889zm-3.981-1.128L22.343 32.4a.89.89 0 0 0 1.257 1.259l1.676-1.676a.89.89 0 0 0-1.259-1.259zM24.148 28a.889.889 0 0 0-.889-.889h-2.37a.889.889 0 1 0 0 1.778h2.37a.889.889 0 0 0 .889-.889zm-.548-5.657a.89.89 0 0 0-1.259 1.257l1.679 1.674a.89.89 0 0 0 1.259-1.259z",
    transform: "translate(-20 -20)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e16893cced9639095b7e67b046990356.svg";
export { ForwardRef as ReactComponent };